// Portado de /tmp/astro/src/pages/bauru.astro (site Astro).
import { MAPS_BUSCA, MAPS_EMBED, NAP } from "@/lib/itv/site";
import { useAgendamentoLink } from "@/lib/itv/agendamento";

// Ortopedia fica sem link de propósito: a divulgação está pendente pelo
// limite de duas especialidades do CFM.
const LOCAIS = [
  {
    titulo: "Nutrólogo em Bauru",
    texto: "Emagrecimento, saúde metabólica e composição corporal.",
    href: "/nutrologo-em-bauru/",
  },
  {
    titulo: "Médico do Esporte em Bauru",
    texto: "Performance, recuperação e saúde de quem treina.",
    href: "/medico-do-esporte-em-bauru/",
  },
  {
    titulo: "Ortopedista em Bauru",
    texto: "Dores de treino, ombro e joelho, com leitura ortopédica.",
  },
  {
    titulo: "Clínica de emagrecimento em Bauru",
    texto: "Tratamento médico com acompanhamento de perto.",
    href: "/medico-para-emagrecer-em-bauru/",
  },
];

export function Bauru() {
  const agendar = useAgendamentoLink();
  return (
    <div className="pag-bauru">
      <section className="hero">
        <div className="container hero-inner">
          <nav className="trilha" aria-label="Você está em">
            <a href="/">Home</a> <span aria-hidden="true">›</span>
            <span>Contato</span> <span aria-hidden="true">›</span> <span>Bauru</span>
          </nav>
          <p className="hero-sobretitulo">ATENDIMENTO PRESENCIAL</p>
          <h1>
            Consultório em <em>Bauru.</em>
          </h1>
          <p className="hero-chamada">
            Consultas com hora marcada no ITV, Instituto Dr. Thiago Viana, com bioimpedância feita
            na própria consulta.
          </p>
        </div>
      </section>

      <section className="endereco-mapa">
        <div className="container endereco-grade">
          <div className="card-endereco">
            <h2 className="rotulo">ENDEREÇO</h2>
            <a className="endereco-link" href={MAPS_BUSCA}>
              <address className="endereco">
                {NAP.logradouro.split(", Sala")[0]}
                <br />
                Sala 7, Torre 2 · {NAP.bairro}
                <br />
                {NAP.cidade}–{NAP.uf} · {NAP.cep}
              </address>
            </a>
            <p className="contato">
              <a href={`tel:${NAP.telefoneE164}`}>{NAP.telefone}</a>
              <br />
              <a href={`mailto:${NAP.email}`}>{NAP.email}</a>
            </p>
            <p className="como-chegar">
              <a href={MAPS_BUSCA}>
                COMO CHEGAR →
              </a>
            </p>
            <a className="btn-ouro btn-endereco" href={agendar}>
              Agendar pelo WhatsApp
            </a>
          </div>

          <div className="mapa">
            <iframe
              src={MAPS_EMBED}
              title={`Mapa do consultório em ${NAP.cidade}`}
              width="600"
              height="450"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      <section className="especialidades">
        <div className="container">
          <p className="sobretitulo">ATENDIMENTO EM BAURU</p>
          <h2>O que você encontra no consultório</h2>
          <p className="especialidades-chamada">
            As especialidades do Dr. Thiago, com página própria para quem busca atendimento na
            cidade:
          </p>
          <ul className="locais">
            {LOCAIS.map((l) => (
              <li className="card-local" key={l.titulo}>
                {l.href ? (
                  <a className="card-local-link" href={l.href}>
                    <h3>{l.titulo}</h3>
                    <p>{l.texto}</p>
                  </a>
                ) : (
                  <>
                    <h3>{l.titulo}</h3>
                    <p>{l.texto}</p>
                  </>
                )}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
